import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Tooltip } from 'react-tooltip';
import configApi from '../../config';

const AllTimeRevenue = () => {
    const [revenue, setRevenue] = useState(0);
    const [isLoading, setIsLoading] = useState(true);
    const token = localStorage.getItem("token");
    const config = {
        headers: {
            Authorization: `Bearer ${token}`,
        },
    };

    useEffect(() => {
        axios.get(`${configApi.apiEndpoint}/api/Stats/DashboardContext`, config)
            .then(response => {
                setRevenue(response.data.allTimeRevenue || response.data.AllTimeRevenue || 0);
                setIsLoading(false);
            })
            .catch(error => {
                console.error('There was an error fetching the all-time revenue:', error);
                setIsLoading(false);
            });
    }, []);

    if (isLoading) {
        return (
            <div className="metric-card w-100 h-100">
                <div className="skeleton-circle"></div>
                <div className="metric-data gap-2">
                    <div className="skeleton-box" style={{ width: '80px', height: '28px' }}></div>
                    <div className="skeleton-box" style={{ width: '120px', height: '14px' }}></div>
                </div>
            </div>
        );
    }

    return (
        <div className="metric-card w-100 h-100">
            <div className="metric-icon" style={{ backgroundColor: '#fff3e0', color: '#ef6c00' }}>
                <i className="bi bi-wallet2"></i>
            </div>
            <div className="metric-data">
                <h3 className="fw-bold m-0 text-dark">{new Intl.NumberFormat('sk-SK').format(revenue)} €</h3>
                <span
                    className="text-muted"
                    style={{ fontSize: '0.85rem', cursor: 'help', borderBottom: '1px dotted #ccc' }}
                    data-tooltip-id="alltime-revenue-tooltip"
                    data-tooltip-content="Hrubý zisk vypočítaný súčtom ceny všetkých realizovaných (zúčastnených) termínov v histórii."
                >
                    Celkový hrubý zisk
                </span>
            </div>
            <Tooltip id="alltime-revenue-tooltip" place="top" effect="solid" />
        </div>
    );
};

export default AllTimeRevenue;
